import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { SbDataService, SbEventBusService } from '@services';
import { ActivatedRoute } from '@angular/router';
import {
    SbKeyValueList,
    SbKeyValueListComponent
} from '../../../shared/components/sb-key-value-list/sb-key-value-list.component';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../../../shared/services/local-storage.service';

@Component({
    standalone: true,
    imports: [CommonModule, SbKeyValueListComponent],
    templateUrl: './sb-key-value-legacy.component.html',
    styleUrls: ['./sb-key-value-legacy.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SbKeyValueLegacyComponent extends BaseWidgetComponent implements OnDestroy {
    constructor(
        dataService: SbDataService,
        localStorageService: LocalStorageService,
        eventBus: SbEventBusService,
        activatedRoute: ActivatedRoute,
        private _cdr: ChangeDetectorRef,
        private translate: TranslateService
    ) {
        super(dataService, localStorageService, eventBus, activatedRoute);
        this.autoTriggerDataLoad = true;
        this.responseHandler = this.setData;
    }

    data: SbKeyValueList = [];

    private setData(data: SbKeyValueList) {
        this.data = data.map((item) => {
            // define key value pair as currency by default if no type is specified
            const keyValuePair = {
                ...item,
                key: this.translate?.instant(item.key) || item.key,
                type: item.type || 'currency'
            };
            // if type is currency, remove decimals by default unless specified
            if (keyValuePair.type === 'currency') {
                keyValuePair['digitsInfo'] = keyValuePair['digitsInfo'] || '1.0-0';
                keyValuePair['useColor'] = !!keyValuePair['useColor']
                    ? keyValuePair['useColor']
                    : true;
            }
            return keyValuePair;
        }) as any;
        this._cdr.markForCheck();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
